import SignupForm from "@pma/components/auth/signup-form";
import AuthLayout from "./layout";

const SignupPage = () => {
  return (
    <AuthLayout>
      <SignupForm />
    </AuthLayout>
  );
};

export default SignupPage;
